import CourseClassTab from './tabs/CourseClassTab'
import CourseInfoTab from './tabs/CourseInfoTab'
import CourseNewsTab from './tabs/CourseNewsTab'
import CourseSubjectTab from './tabs/CourseSubjectTab'

export const courseRouteEntities = [
  {
    path: 'overview',
    component: CourseInfoTab,
    breadcrumbName: (t) => t('overview'),
  },
  {
    path: 'news',
    component: CourseNewsTab,
    breadcrumbName: (t) => t('news'),
    isInvisible: (props) => !!props?.item?.warnings,
  },
  {
    path: 'subjects',
    component: CourseSubjectTab,
    breadcrumbName: (t) => t('subjects'),
    isInvisible: (props) => !!props?.item?.warnings,
  },
  {
    path: 'classes',
    component: CourseClassTab,
    breadcrumbName: (t) => t('classes'),
    isInvisible: (props) => !!props?.item?.warnings,
  },
]
